import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import ProjectInfo from '../projectinfo/ProjectInfo';
import Chart from '../chart/Chart';
import PriceBox from '../pricebox/PriceBox';
import DexInfo from '../dex-info/DexInfo';
import QuickAudit from '../quickaudit/QuickAudit';
import AuditResults from '../audit-results/AuditResults';
import QuickAuditHeader from '../quickauditheader/QuickAuditHeader';
import AuditHeader from '../auditheader/AuditHeader';
import Transactions from '../transactions/Transactions';
import SocialOverview from '../socialoverview/SocialOverview';
import HoldersTime from '../holderstime/HoldersTime';
import AdBar from '../adbar/AdBar';
import Presale from '../presale/Presale';
import Traders from '../traders/Traders';
import Ai from '../ai/Ai';
import Holders from '../holders/Holders';
import Snipers from '../snipers/Snipers';
import Unlisted from '../unlisted/Unlisted';
import HolderData from '../holderdata/HolderData';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import './TokenPage.css';
import { AiOutlineSafetyCertificate  } from "react-icons/ai";
import { LiaExternalLinkAltSolid } from "react-icons/lia";
import { PiFingerprint } from "react-icons/pi";
import { ProgressBar } from 'react-bootstrap';
import { TokenItem } from '../../utils/types';
import Marquee from 'react-fast-marquee';
import { Helmet } from 'react-helmet-async';
import ScoreBar from '../scorebar/ScoreBar';
import KycCertificate from '../kyc-certificate/KycCertificate';

const External = LiaExternalLinkAltSolid as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TimesIcon = AiOutlineSafetyCertificate  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const KYC = PiFingerprint  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

const allowedChains = ['bsc', 'eth', 'sol', 'base', 'arbitrum', 'polygon', 'avax', 'pepu', 'robin'];
const CUSTOM_PEPU_ADDRESS = '0x0512eEfc949Ec7aF6f50196D9B5e525C35fBB447';

const TokenPage: React.FC = () => {
  const { chain, address } = useParams<{ chain: string; address?: string }>();
  const navigate = useNavigate();
  const isCustomPepuView =
    chain?.toLowerCase() === 'pepu' &&
    address?.toLowerCase() === CUSTOM_PEPU_ADDRESS.toLowerCase();

  useEffect(() => {
    if (chain && chain.toLowerCase() === 'solana') {
      navigate(`/sol/${address || ''}`, { replace: true });
    }
  }, [chain, address, navigate]);

  const isValidChain = chain && allowedChains.includes(chain.toLowerCase());

  const [data, setData] = useState<any>(null);
  const [isListed, setIslisted] = useState<any>(false);
  const [csListed, setCslisted] = useState<any>(false);
  const [priceData, setPriceData] = useState<any>(null);
  const [holderData, setHolderData] = useState<any>(null);
  const [scanData, setScanData] = useState<any>(null);
  const [athData, setAthData] = useState<any>(null);
  const [chainId, setChainId] = useState<any>(null);
  const [projectDatabase, setProjectDatabase] = useState<TokenItem[]>([]);
  const [pairAddress, setPairAddress] = useState<string | null>(null);
  const [pageTitle, setPageTitle] = useState('Coinsult Token Dashboard');
  const [pageDesc,  setPageDesc]  = useState('View realtime security insights price charts, trading history and helpfull info.');
  const [pageImg,   setPageImg]   = useState<string | null>(null);

useEffect(() => {
  let title = 'Project';
  let desc  = 'View realtime security insights price charts, trading history and helpfull info.';
  let img   = null;

  if (scanData && Object.keys(scanData).length > 0) {
    const s = Object.values(scanData)[0] as any;
    if (s.token_symbol) title = s.token_symbol;
  }
  
  if (data?.data) {
    title  += `: $${formatVolume(data.data.fdv)} – ${data.data.baseTokenData.name}`;
    desc   = `${data.data.baseTokenData.name} - ${data.data.baseTokenData.symbol}: View realtime security insights for ${data.data.baseTokenData.name} price charts, trading history and helpful info.`;
    img    = data.data.baseTokenData.logoURI || img;
  }

  setPageTitle(`${title} | Coinsult`);
  setPageDesc(desc);
  setPageImg(img);
}, [data, scanData]);

  const dataString =
  'Audit Information: ' +
  (projectDatabase ? JSON.stringify(projectDatabase) : 'No Project Data') +
  ' Autoscanner Information: ' +
  (scanData ? JSON.stringify(scanData) : 'No Scan Data') +
  ' Pair Information: ' +
  (priceData ? JSON.stringify(priceData) : 'No Price Data');

  useEffect(() => {
    if (!chain) return;
    const lowerChain = chain.toLowerCase();
    if (lowerChain === 'bsc') {
      setChainId(56);
    } else if (lowerChain === 'eth') {
      setChainId(1);
    } else if (lowerChain === 'sol' || lowerChain === 'solana') {
      setChainId(501424);
    } else if (lowerChain === 'base') {
      setChainId(8453);
    } else if (lowerChain === 'arbitrum') {
      setChainId(42161);
    } else if (lowerChain === 'polygon') {
      setChainId(137);
    } else if (lowerChain === 'avax') {
      setChainId(43114);
    } else if (lowerChain === 'robin') {
      setChainId(4663);
    } else {
      setChainId(null);
    }
  }, [chain]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`https://coinsult.dev/wp-json/wp/v2/tokens?contract_address=${address}`);
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        const data: TokenItem[] = await res.json();
        setProjectDatabase(data);
        if (data.length > 0){
          setCslisted(true);
        }
      } catch (err: any) {
        console.error(err.message);
      }
    };

    if (address) {
      fetchData();
    }
  }, [address]);
  
  useEffect(() => {
    if (address === null || !isValidChain || chainId === null) return;
    const fetchData = async () => {
      try {
        if (address === "2RA1v8NdkEQcF5N5zHUqLuAHxjnDMQFjwEE8fwKNpump"){
          return;
        }
        const response = await fetch(`https://api.dexview.com/pair?baseToken=${address}&chainId=${chainId}`, {
            headers: {
              "accept": "application/json, text/plain, */*",
              "accept-language": "nl-NL,nl;q=0.9,en-US;q=0.8,en;q=0.7",
              "if-none-match": "W/\"2244-8e+vWX7JgZT7/hBnItO2lL1ZTqo\"",
              "priority": "u=1, i",
              "sec-ch-ua": "\"Not(A:Brand\";v=\"99\", \"Google Chrome\";v=\"133\", \"Chromium\";v=\"133\"",
              "sec-ch-ua-mobile": "?0",
              "sec-ch-ua-platform": "\"Windows\"",
              "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors",
              "sec-fetch-site": "same-site",
              "secret": "5ff3a258-2700-11ed-a261-0242ac120002"
            },
            referrerPolicy: "same-origin",
            body: null,
            method: "GET",
            mode: "cors",
            credentials: "omit"
        });
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        setData(result);
        setPairAddress(result?.data?.address);
        console.log(data);
        if(result.data === null){
          setIslisted(false);
        } else if (result.data?.liquidity < 500){
          setIslisted(false);
        } else {
          setIslisted(true);
        }
      } catch (error: any) {
        console.error(error);
      }
    };
    fetchData();

    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, [chainId, address]);

  // get price data based on pair address
  useEffect(() => {
    if (address === null || !isValidChain || chainId === null || !pairAddress) return;
  
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://api.dexview.com/pair/pair-metrics?chainId=${chainId}&address=${pairAddress}`,
          {
            headers: {
              "accept": "application/json, text/plain, */*",
              "accept-language": "nl-NL,nl;q=0.9,en-US;q=0.8,en;q=0.7",
              "if-none-match": 'W/"7ff-hLIJGnGgCD9Spmjii3+5OZpj3H4"',
              "priority": "u=1, i",
              "sec-ch-ua": '"Not(A:Brand";v="99", "Google Chrome";v="133", "Chromium";v="133"',
              "sec-ch-ua-mobile": "?0",
              "sec-ch-ua-platform": '"Windows"',
              "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors",
              "sec-fetch-site": "same-site",
              "secret": "5ff3a258-2700-11ed-a261-0242ac120002"
            },
            referrerPolicy: "same-origin",
            body: null,
            method: "GET",
            mode: "cors",
            credentials: "omit"
          }
        );
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        setPriceData(result);
      } catch (error) {
        console.error(error);
      }
    };
  
    fetchData();
    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, [chainId, pairAddress, isValidChain, address]);  

  // get holder data
  useEffect(() => {
    if (address === null || !isValidChain || chainId === null || !pairAddress) return;
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://api.dexview.com/token/top-holders?chainId=${chainId}&tokenAddress=${address}&isContract=true`,
          {
            headers: {
              "accept": "application/json, text/plain, */*",
              "accept-language": "nl-NL,nl;q=0.9,en-US;q=0.8,en;q=0.7",
              "if-none-match": 'W/"7ff-hLIJGnGgCD9Spmjii3+5OZpj3H4"',
              "priority": "u=1, i",
              "sec-ch-ua": '"Not(A:Brand";v="99", "Google Chrome";v="133", "Chromium";v="133"',
              "sec-ch-ua-mobile": "?0",
              "sec-ch-ua-platform": '"Windows"',
              "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors",
              "sec-fetch-site": "same-site",
              "secret": "5ff3a258-2700-11ed-a261-0242ac120002"
            },
            referrerPolicy: "same-origin",
            body: null,
            method: "GET",
            mode: "cors",
            credentials: "omit"
          }
        );
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        setHolderData(result);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, [chainId, pairAddress, isValidChain, address]);  

  // get ath data
  useEffect(() => {
    if (address === null || !isValidChain || chainId === null || !pairAddress) return;
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://api.dexview.com/pair/extra-info?chainId=${chainId}&address=${pairAddress}`,
          {
            headers: {
              "accept": "application/json, text/plain, */*",
              "accept-language": "nl-NL,nl;q=0.9,en-US;q=0.8,en;q=0.7",
              "if-none-match": 'W/"7ff-hLIJGnGgCD9Spmjii3+5OZpj3H4"',
              "priority": "u=1, i",
              "sec-ch-ua": '"Not(A:Brand";v="99", "Google Chrome";v="133", "Chromium";v="133"',
              "sec-ch-ua-mobile": "?0",
              "sec-ch-ua-platform": '"Windows"',
              "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors",
              "sec-fetch-site": "same-site",
              "secret": "5ff3a258-2700-11ed-a261-0242ac120002"
            },
            referrerPolicy: "same-origin",
            body: null,
            method: "GET",
            mode: "cors",
            credentials: "omit"
          }
        );
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        setAthData(result.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, [chainId, pairAddress, isValidChain, address]);  

  // get autoscan data
  useEffect(() => {
    if (address === null || !isValidChain || chainId === null) return;
    const fetchData = async () => {
      try {
        let url;
        if (chainId === 501424) {
          url = `https://api.gopluslabs.io/api/v1/solana/token_security?contract_addresses=${address}`;
        } else {
          url = `https://api.gopluslabs.io/api/v1/token_security/${chainId}?contract_addresses=${address}`;
        }
        const response = await fetch(url, {
          headers: {
            "accept": "application/json, text/plain, */*",
            "accept-language": "nl-NL,nl;q=0.9,en-US;q=0.8,en;q=0.7",
            "if-none-match": 'W/"7ff-hLIJGnGgCD9Spmjii3+5OZpj3H4"',
            "priority": "u=1, i",
            "sec-ch-ua": '"Not(A:Brand";v="99", "Google Chrome";v="133", "Chromium";v="133"',
            "sec-ch-ua-mobile": "?0",
            "sec-ch-ua-platform": '"Windows"',
            "sec-fetch-dest": "empty",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "same-site"
          },
          referrerPolicy: "same-origin",
          body: null,
          method: "GET",
          mode: "cors",
          credentials: "omit"
        });
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        setScanData(result.result);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();    
  }, [chainId, address]);  

  const formatVolume = (volume: number): string => {
    if (volume === null || volume === undefined) return '-';

    if (Math.abs(volume) >= 1_000_000_000) {
      return (
        (volume / 1_000_000_000).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + 'B'
      );
    } else if (Math.abs(volume) >= 1_000_000) {
      return (
        (volume / 1_000_000).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + 'M'
      );
    } else if (Math.abs(volume) >= 1_000) {
      return (
        (volume / 1_000).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + 'K'
      );
    }
    return volume.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <>
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <link rel="canonical" href={`https://coinsult.net/${chain}/${address}`} />

      <meta property="og:type"        content="website" />
      <meta property="og:title"       content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      {pageImg && <meta property="og:image" content={pageImg} />}

      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      {pageImg && <meta name="twitter:image" content={pageImg} />}
    </Helmet>
    {<AdBar />}
    <div className='token-frame'>
      {!isValidChain ? (
        <div>
          <p>
            Invalid chain provided. Allowed chains are: {allowedChains.join(', ')}
          </p>
        </div>
      ) : !address ? (
        <div>Loading token...</div>
      ) : (
        <>
          <div className='left-panel'>
            <ProjectInfo data={data} priceData={priceData} scanData={scanData} ca={address} chainId={chainId} projectDb={projectDatabase} pairAddress={pairAddress} />
            {!isCustomPepuView && (
              <>
                <div className="buttons-wrapper">
                    {/* <a className='full-width-button' href={`https://web3.okx.com/dex-swap?${address}`} target='_blank'>
                      <div>Buy now</div> <External />
                    </a> */}
                  {!csListed ? (
                    <a className="full-width-button listnow" href='/list'>
                      <div>List now</div>
                    </a>
                  ) : 
                  <a className='full-width-button listnow' href='/advertise' target='_blank'>Advertise</a>
                  }

                  {projectDatabase && projectDatabase[0]?.meta?.verified !== "true" && (
                    <a className='full-width-button listnow' href='https://t.me/coinsult_tg' target='_blank'>Get Verified</a>
                  )}
                </div>

                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className='sec-hed'>
                      <div className="security-header">
                        <h4>Degen Scanner</h4>
                        {scanData && chainId && (
                          <QuickAuditHeader scanData={scanData} chainId={chainId} />
                        )}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="quick-auditcordion">
                      {scanData && chainId && <QuickAudit data={scanData} chain={chainId} />}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className='sec-hed'>
                      <div className="security-header ai-header">
                        <h4>AI Agent (beta)</h4>
                        <p className='ai-note'>Custom AI Agent for this project</p>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="quick-auditcordion">
                        {dataString && chainId && csListed && (
                          <Ai ca={address} data={dataString} pair={pairAddress || ''} />
                        )}

                        {!csListed && (
                          <Unlisted />
                        )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className='sec-hed'>
                      <div className="security-header">
                        <h4>Live Holders</h4>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="quick-auditcordion">
                        {scanData && chainId && csListed && (
                          <Holders ca={address} chain={chain} />
                        )}

                        {!csListed && (
                          <Unlisted />
                        )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </>
            )}

          </div>
          <div className='right-panel'>
            {!isCustomPepuView && (
              <div className="chart-dex">
              {!isListed &&(
                <Presale ca={address} data={projectDatabase} />
              )}

              {data && priceData && pairAddress && athData && isListed && (    
                <>
                  <div className="chartandtxbox">
                    <div className='chart-box'>
                      <Chart address={pairAddress} chain={chain} />
                    </div>
                    <div className="tx-box">
                      {pairAddress && chain && (
                        <Transactions 
                        pair={pairAddress} 
                        chainId={chainId} 
                        />
                      )}
                    </div>
                  </div>
                  <div className='info-box'>
                    <PriceBox data={data.data?.newInformation} extraData={priceData.data} />
                    <DexInfo 
                      data={data.data} 
                      extraData={priceData.data} 
                      holderData={holderData} 
                      athData={athData} 
                      scannerData={scanData} 
                      chainId={chainId} 
                    />
                  </div>
                </>
              )}
              </div>
            )}

            <div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className='sec-hed'>
                    <AuditHeader tokens={projectDatabase}/>
                  </Accordion.Header>
                  <Accordion.Body>
                    <AuditResults ca={address} tokens={projectDatabase} />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            {projectDatabase.length > 0 &&
              projectDatabase[0].meta.badges.KYC === "true" && (
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className='sec-hed'>
                      <div className='kyc-header-row'>
                        <h4>KYC Verified</h4>
                        <div className='kyc-header-badges'>
                          <span className='kyc-header-badge kyc-identity'>
                            <KYC />
                            Owner identity verified
                          </span>
                          <span className='kyc-header-badge'>
                            <img src="/images/gdpr.png" alt="GDPR" />
                            GDPR Compliant
                          </span>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <KycCertificate tokens={projectDatabase} />
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              )}

              {isCustomPepuView ? (
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className='sec-hed'>
                      <h4>Community Overview</h4>
                    </Accordion.Header>
                    <Accordion.Body>
                      {address && csListed && (
                        <SocialOverview ca={address} />
                      )}

                      {!csListed && (
                        <Unlisted />
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              ) : (
                <>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className='sec-hed'>
                    <h4>Holder Analysis</h4>
                  </Accordion.Header>
                  <Accordion.Body>
                    {address && chain && csListed && (
                      <HolderData ca={address} chain={chain} />
                    )}

                    {!csListed && (
                      <Unlisted />
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className='sec-hed'>
                      <h4>Community Overview</h4>
                    </Accordion.Header>
                    <Accordion.Body>
                      {address && csListed && (
                        <SocialOverview ca={address} />
                      )}

                      {!csListed && (
                        <Unlisted />
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className='sec-hed'>
                      <h4>Transaction Data</h4>
                    </Accordion.Header>
                    <Accordion.Body>
                      {address && csListed && pairAddress && (
                        <HoldersTime ca={address} />
                      )}

                      {csListed && !pairAddress &&(
                        <div className="not-found">
                          No liquidity yet... 🕐
                        </div>
                      )}

                      {!csListed && (
                        <Unlisted />
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

              <Tabs
                defaultActiveKey="traders"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="traders" title="Traders">
                  <div className="box-basic">
                  {csListed ? (
                    pairAddress && chain ? (
                      <Traders ca={address} chain={chain} />
                    ) : (
                      <div className='not-found'>No liquidity yet... 🕐</div>
                    )
                  ) : (
                    <Unlisted />
                  )}
                  </div>
                </Tab>
                <Tab eventKey="overview" title="Snipers">
                  <div className="box-basic">
                    {csListed ? (
                      pairAddress && chain ? (
                        <Snipers pair={pairAddress} chain={chain} />
                      ) : (
                        <div className='not-found'>No liquidity yet... 🕐</div>
                      )
                    ) : (
                      <Unlisted />
                    )}
                  </div>
                </Tab>
              </Tabs>
                </>
              )}
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className='sec-hed'>
                    <h4>Disclaimer</h4>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className='disclaimer-box'>
                      <p>
                        This page has been prepared by Coinsult&apos;s experts at the request of the client. The purpose of this page is to provide information regarding the token&apos;s smart contract and present findings related strictly to <strong>code safety and security analysis</strong>.
                      </p>
                      <p>
                        Coinsult&apos;s review focuses exclusively on the smart contract code and its technical implementation. Our analysis is intended to identify potential vulnerabilities, security risks, malicious code patterns, and other technical concerns that may affect the safety of the contract.
                      </p>
                      <p>
                        This page should not be interpreted as an endorsement, approval, or guarantee of the project, its team, tokenomics, business model, or future performance. Coinsult does not evaluate the legitimacy, profitability, sustainability, or investment potential of any project.
                      </p>
                      <p>
                        Coinsult does not provide financial, investment, legal, or trading advice. Any information presented on this page is strictly for informational and educational purposes. Users should always conduct their own independent research before interacting with any blockchain project or token.
                      </p>
                      <p>
                        Coinsult cannot be held responsible for any financial losses, damages, exploits, hacks, rug-pulls, honeypots, scams, or other issues that may arise from the use of the project or token.
                      </p>
                      <p>
                        Our role is limited solely to reviewing the smart contract code for security-related observations at the time of analysis. No assessment can guarantee complete security, eliminate all risks, or predict future changes made to the contract or project infrastructure.
                      </p>
                      <p>
                        By using this information, you acknowledge that all blockchain interactions carry inherent risks and that Coinsult bears no liability for decisions made based on this analysis.
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

          </div>
        </>
      )}
    </div>
    </>
  );
};

export default TokenPage;
